export default __webpack_public_path__ + "static/media/img_background.089030cd.jpg";